import { useLayoutEffect, useRef, useState } from 'react';
import { useResizeObserver } from 'usehooks-ts';

import type { RefObject } from 'react';

import { useScrollDirection } from 'hooks/useScrollDirection';
import { getScrollableParent } from 'support/helpers/scroll/scroll';

type UsePartialStickyHeaderReturn = {
  scrollableSectionRef: RefObject<HTMLDivElement | null>;
  scrollableSectionHeight: number;
  isHeaderVisible: boolean;
};

export const usePartialStickyHeader = (enabled: boolean): UsePartialStickyHeaderReturn => {
  const scrollableSectionRef = useRef<HTMLDivElement>(null);
  const [scrollableElement, setScrollableElement] = useState<HTMLElement | null>(null);

  const { height = 0 } = useResizeObserver({
    ref: scrollableSectionRef as RefObject<HTMLDivElement>,
    box: 'border-box',
  });

  useLayoutEffect(() => {
    if (!enabled) {
      setScrollableElement(null);
      return;
    }

    if (!scrollableSectionRef.current) {
      return;
    }

    const scrollableParent = getScrollableParent(scrollableSectionRef.current);
    setScrollableElement(scrollableParent);
  }, [enabled]);

  const { scrollDirection, scrollY } = useScrollDirection(10, scrollableElement, enabled);
  const isHeaderVisible = scrollDirection === 'up' || scrollDirection === 'idle' || scrollY <= 10;

  return {
    scrollableSectionRef,
    scrollableSectionHeight: enabled ? height : 0,
    isHeaderVisible,
  };
};
